import { render, staticRenderFns } from "./PremiumWarning.vue?vue&type=template&id=7cdd2c28&"
import script from "./PremiumWarning.vue?vue&type=script&lang=js&"
export * from "./PremiumWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports